export const domain = (path?: string) =>
  `https://elbatoul-eg.com${path ? "/" + path : ""}`;
// `https://react.hanstarcarrental.com${path ? "/" + path : ""}`;
// `https://egyptos-travel.com${path ? "/" + path : ""}`;
